import { Component, OnInit } from '@angular/core';
import { CotizadoresService } from 'src/app/services/cotizadores.service';

@Component({
  selector: 'cotizadores',
  templateUrl: './cotizadores.component.html',
  styleUrls: ['./cotizadores.component.css']
})
export class CotizadoresComponent implements OnInit {

  constructor(private cotizadoresService: CotizadoresService) { }

  ngOnInit(): void {

  }

  resetEditItem() {
    this.cotizadoresService.setEditItem(null)
  }

}
